import {
  ITradesElecData,
  ITradesElecHistoryData,
  ITradesElecNominationsData,
} from "./elecData.types"
import { Dayjs } from "dayjs"

export class TradesElecData implements ITradesElecData {
  constructor(
    public id: number,
    public date: Dayjs | null,
    public product: string | null,
    public period: string | null,
    public price: number | null,
    public volume: number | null,
    public totalVolume: number,
    public invoiceDateFrom: Dayjs | null,
    public invoiceDateTo: Dayjs | null,
    public counterParty: string | null,
    public trader: string | null,
    public notes: string | null,
    public confirmReceivedDate: Dayjs | null,
    public confirmSignedDate: Dayjs | null,
    public confirmSignedBy: string | null,
    public percentOfBaseload: number | null,
    public locked: boolean,
  ) {}
}

export class TradesElecHistoryData implements ITradesElecHistoryData {
  constructor(
    public id: number,
    public elecTradeId: number,
    public date: Dayjs | null,
    public product: string | null,
    public period: string | null,
    public price: number | null,
    public volume: number | null,
    public totalVolume: number,
    public invoiceDateFrom: Dayjs | null,
    public invoiceDateTo: Dayjs | null,
    public counterParty: string | null,
    public trader: string | null,
    public notes: string | null,
    public confirmReceivedDate: Dayjs | null,
    public confirmSignedDate: Dayjs | null,
    public confirmSignedBy: string | null,
    public percentOfBaseload: number | null,
  ) {}
}

export class TradesElecNominationsData implements ITradesElecNominationsData {
  constructor(
    public hour1: number | null,
    public hour2: number | null,
    public hour3: number | null,
    public hour4: number | null,
    public hour5: number | null,
    public hour6: number | null,
    public hour7: number | null,
    public hour8: number | null,
    public hour9: number | null,
    public hour10: number | null,
    public hour11: number | null,
    public hour12: number | null,
    public hour13: number | null,
    public hour14: number | null,
    public hour15: number | null,
    public hour16: number | null,
    public hour17: number | null,
    public hour18: number | null,
    public hour19: number | null,
    public hour20: number | null,
    public hour21: number | null,
    public hour22: number | null,
    public hour23: number | null,
    public hour24: number | null,
    public hour25: number | null,
    public createdAt: Dayjs | null,
    public updatedAt: Dayjs | null,
    public date: Dayjs | null,
    public trader: string | null,
  ) {}
}
